import './header.css';
import Logo from '../../images/logo.png'
import ModalConfirm from '../modais/ModalConfirm';
import { ReactComponent as IconeSair } from '../../assets/icones/logout.svg';
import { ReactComponent as IconeMenu } from '../../assets/icones/menu.svg';
import { useDispatch } from 'react-redux';
import { logout } from '../../features/auth/logoutSlice';
import { Fragment, useState } from 'react';
import { useStoreContext } from '../../hooks/context/StoreContext';

const Header = ({ titulo, onToggleMenu, isMenuOpen, click }) => {
    const {
        modal,
        setModal
    } = useStoreContext();

    const [apiCarregando, setApiCarregando] = useState(false);

    const handleToggleMenu = onToggleMenu || click;

    const btnLogout = () => {
        setModal(prev => ({
            ...prev,
            identificadorModalConfirm: 'logout',
            openModalConfirm: true,
            tituloModalConfirm: 'Atenção',
            subtituloModalConfirm: 'Tem certeza que deseja sair?',
            textoModalConfirm: '',
        }));
    };

    const handleLogout = async () => {
        setApiCarregando(true);

        try {
            setModal(prev => ({
                ...prev,
                identificadorModalConfirm: '',
                openModalConfirm: false,
                subtituloModalConfirm: '',
                textoModalConfirm: '',
            }));

        } catch (error) {
            console.log(error)
        } finally {
            setApiCarregando(false);
        };
    };

    return (
        <Fragment>
            <header className='container-header'>
                <div className='header-logo'>
                    <button
                        type='button'
                        className='header-icon-menu'
                        aria-label={isMenuOpen ? 'Fechar menu' : 'Abrir menu'}
                        aria-expanded={!!isMenuOpen}
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={handleToggleMenu}
                    >
                        <IconeMenu width='24px' height='24px' fill='#212121' />
                    </button>
                    <img src={Logo} alt='Logo OG1' title='Logo OG1' width='75px' />
                    <h3>{titulo}</h3>
                </div>
                <div
                    tabIndex={0}
                    className='container-logout'
                    onClick={() => btnLogout()}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            btnLogout();
                        };
                    }}
                >
                    <IconeSair
                        width={'22px'}
                        fill={'#212121'}
                        fillOpacity={'0.8'}
                    />
                    <span className='logout-text'>Sair</span>
                </div>
            </header>
            <ModalConfirm
                isOpen={modal.openModalConfirm}
                closeModal={() => setModal(prev => ({ ...prev, openModalConfirm: false }))}
                titulo={modal.tituloModalConfirm}
                primeiroTexto={modal.subtituloModalConfirm}
                segundoTexto={modal.textoModalConfirm}
                confirm={() => handleLogout()}
                loading={apiCarregando}
            />
        </Fragment>
    );
};

export default Header;
